module.exports = __webpack_public_path__ + "static/media/SoundOff.cc4447e9.mp3";